const data = {
  city: [
    {
      id: 1,
      name: '安徽',
      companyName: '安徽省品农汽车服务有限公司',
      address: '安徽省合肥市蜀山区新城国际C座1303室',
      tel: '0551-65877860',
      img: require('@image/ah.png')
    },
    {
      id: 2,
      name: '北京',
      companyName: '北京品农汽车服务有限公司',
      address: '北京市昌平区东小口镇中东路5号院4号4层407',
      tel: '15633019868',
      img: require('@image/bj.png')
    },
    {
      id: 3,
      name: '重庆',
      companyName: '重庆品农汽车销售服务有限公司',
      address: '重庆渝中区人民路248号盛迪亚商务大厦2306',
      tel: '023-63032215',
      img: require('@image/cq.png')
    },
    {
      id: 4,
      name: '福建',
      companyName: '品农安（厦门）汽车服务有限公司',
      address: '厦门市集美区杏林湾商务运营中心6#1303a',
      tel: '18046292219',
      img: require('@image/xm.png')
    },
    {
      id: 5,
      name: '广东',
      children: [
        {
          companyName: '东莞市品农汽车服务有限公司',
          address: '广东省东莞市南城街道鸿福西路南城段80号希尔顿广场1栋818室',
          tel: '13509288250',
          img: require('@image/dg.png')
        },
        {
          companyName: '广州市品农汽车服务有限公司',
          address: '广东省广州市天河区天河路228号之一广晟大厦1303室',
          tel: '020-31529860,18027206966',
          img: require('@image/gzpn.png')
        }
      ]
    },
    {
      id: 6,
      name: '广西',
      companyName: '广西品农汽车服务有限公司',
      address: '广西省南宁市西乡塘区安吉万达广场SOHO公寓2栋11楼1115号',
      img: require('@image/gx.png'),
      tel: '19163605393'
    },
    {
      id: 7,
      name: '贵州',
      companyName: '贵州品农商用车服务有限公司',
      address: '贵州省贵阳市观山湖区富力中心A2栋605室',
      tel: '0851-84724833',
      img: require('@image/gz.png')
    },
    {
      id: 8,
      name: '海南',
      companyName: '海南品农汽车服务有限公司 ',
      address: '海南省海口市龙华区玉沙路16号富豪大厦B座第五层504房',
      tel: '0898-68532319',
      img: require('@image/hnpn_.png')
    },

    {
      id: 9,
      name: '河北',
      children: [
        {
          companyName: '河北品农汽车服务有限公司',
          address: '河北省石家庄市新华区鹿城苑商务楼1-1701',
          tel: '15633019868',
          img: require('@image/hbpn.png')
        },
        {
          companyName: '唐山品农汽车服务有限公司',
          address: '河北省唐山市路北区学院路君瑞国际（新华一号）3号楼2204',
          tel: '18931548656',
          img: require('@image/ts.png')
        }
      ]
    },
    {
      id: 10,
      name: '河南',
      companyName: '河南品农汽车服务有限公司',
      address: '河南省郑州市郑东新区商务外环路25号王鼎国际705室',
      tel: '0371-86228088',
      img: require('@image/hn.png')
    },
    {
      id: 11,
      name: '湖北',
      companyName: '湖北品农商用车服务有限公司',
      address: '湖北省武汉市武昌区武珞路421号帝斯曼国际中心三号楼25楼',
      tel: '400-800-7969',
      img: require('@image/wh.png')
    },
    {
      id: 26,
      name: '黑龙江',
      companyName: '黑龙江品农汽车服务有限公司',
      address: '黑龙江省哈尔滨市南岗区红军街15号奥威斯发展大厦15楼E',
      tel: '15392889413',
      img: require('@image/hlj.jpg')
    },
    {
      id: 12,
      name: '湖南',
      companyName: '湖南品农汽车服务有限公司',
      address: '湖南省长沙市长沙县开元中路湘商世纪鑫城1006室 ',
      tel: '0731-86468233',
      img: require('@image/hnpn.png')
    },
    {
      id: 13,
      name: '江苏',
      children: [
        {
          companyName: '南京品农汽车服务有限公司',
          address: '江苏省南京市秦淮区洪武路359号福鑫大厦3301西',
          tel: '025-83309299',
          img: require('@image/nj.png')
        },
        {
          companyName: '连云港品农汽车服务有限公司',
          address: '江苏省连云港市海州区海连东路26号润潮国际大厦1705A',
          tel: '18360350717',
          img: require('@image/lyg.png')
        }
      ]
    },
    {
      id: 14,
      name: '江西',
      companyName: '江西品农汽车服务有限公司',
      address: '江西省南昌市红谷滩新区世贸路699号联泰7号广场B座1337室',
      tel: '0791-86399717',
      img: require('@image/jx.png')
    },
    {
      id: 15,
      name: '辽宁',
      companyName: '辽宁省品农汽车销售有限公司',
      address: '辽宁省沈阳市沈河区北站路57号财富中心D座1903',
      tel: '024-31652287',
      img: require('@image/ln.png')
    },
    {
      id: 16,
      name: '内蒙古',
      companyName: '内蒙古品农汽车服务有限责任公司',
      address: ' 内蒙古自治区呼和浩特市赛罕区乌兰察布路97号天辰银筑7017',
      img: require('@image/nmg.png'),
      tel: '15560915782'
    },

    {
      id: 17,
      name: '山东',
      children: [
        {
          companyName: '青岛品农汽车服务有限公司',
          address: '山东省青岛市市南区香港中路36号招银大厦809室',
          tel: '0532-80970420',
          img: require('@image/qd.png')
        },
        {
          companyName: '济南品农汽车服务有限公司',
          address: '山东省济南市历下区历山路173号历山名郡B座508室',
          tel: '0531-82926323',
          img: require('@image/jn.png')
        }
      ]
    },
    {
      id: 18,
      name: '山西',
      companyName: '太原市品农汽车服务有限公司',
      address: ' 山西省太原市小店区亲贤北街昌盛双喜城SOHO 608',
      img: require('@image/ty.png'),
      tel: '13233413115'
    },

    {
      id: 19,
      name: '陕西',
      children: [
        {
          companyName: '西安品农汽车服务有限公司',
          address: '陕西省西安市雁塔区沣惠南路摩尔中心B栋1002室',
          tel: '029-88217865',
          img: require('@image/xa.png')
        },
        {
          companyName: '榆林品农安汽车服务有限公司',
          address: '陕西省榆林市榆阳区青云乡刘家洼村二组27号',
          tel: '18092177581',
          img: require('@image/yl.png')
        }
      ]
    },
    {
      id: 20,
      name: '上海',
      companyName: '上海品农汽车服务有限公司',
      address: '上海市宝山区同济支路199号4幢3号楼508室',
      tel: '18119312253',
      img: require('@image/shpn.png')
    },
    {
      id: 21,
      name: '四川',
      companyName: '四川品农汽车服务有限公司 ',
      address: '四川省成都市新都区斑竹园镇北星大道二段757号精企楼9楼7-8号',
      tel: '028-68484158',
      img: require('@image/sc.png')
    },
    {
      id: 22,
      name: '天津',
      companyName: '天津品农汽车服务有限公司',
      address: '天津市东丽区汇城广场1803',
      tel: '022-25311608',
      img: require('@image/tj.png')
    },
    {
      id: 23,
      name: '新疆',
      companyName: '新疆品农汽车服务有限公司',
      address: '新疆乌鲁木齐市水磨沟区会展大道1119号乌鲁木齐晚报大厦A座709',
      tel: '18871882592',
      img: require('@image/xjpn.jpg')
    },

    {
      id: 24,
      name: '云南',
      companyName: '昆明品农汽车服务有限公司',
      address: '云南省昆明市盘龙区金辰街道欣都龙城1号商务楼14层1404室',
      tel: '13208894687',
      img: require('@image/km.png')
    },

    {
      id: 25,
      name: '浙江',
      companyName: '浙江品农商用车服务有限公司',
      address: '浙江省杭州市下城区东新路533号蔚蓝国际1116室',
      tel: '0571-85350213',
      img: require('@image/zj.png')
    }
  ],
  province: [
    {
      name: '北京'
    },
    {
      name: '天津'
    },
    {
      name: '上海'
    },
    {
      name: '重庆'
    },
    {
      name: '河北'
    },
    {
      name: '河南'
    },
    {
      name: '云南'
    },
    {
      name: '辽宁'
    },
    {
      name: '黑龙江'
    },
    {
      name: '湖南'
    },
    {
      name: '安徽'
    },
    {
      name: '山东'
    },
    {
      name: '新疆'
    },
    {
      name: '江苏'
    },
    {
      name: '浙江'
    },
    {
      name: '江西'
    },
    {
      name: '湖北'
    },
    {
      name: '广西'
    },
    { name: '甘肃' },
    {
      name: '山西'
    },
    {
      name: '内蒙古'
    },
    {
      name: '陕西'
    },
    { name: '吉林' },
    {
      name: '福建'
    },
    {
      name: '贵州'
    },
    {
      name: '广东'
    },
    { name: '青海' },
    { name: '西藏' },
    {
      name: '四川'
    },
    { name: '宁夏' },
    {
      name: '海南'
    },
    { name: '台湾' },
    { name: '香港' },
    { name: '澳门' }
  ],
  // 合作厂家
  company: [
    { name: '东风商用车有限公司' },
    { name: '中国重汽集团济南卡车股份有限公司' },
    { name: '陕西重型汽车有限公司' },
    { name: '北京福田戴姆勒汽车有限公司' },
    { name: '上汽依维柯红岩商用车有限公司' },
    { name: '安徽江淮汽车集团股份有限公司' },
    { name: '徐州徐工汽车制造有限公司' },
    { name: '华菱星马汽车（集团）股份有限公司' },
    { name: '集瑞联合卡车营销服务有限公司' },
    { name: '北奔重型汽车集团有限公司' },
    { name: '江铃重型汽车有限公司' },
    { name: '东风华神汽车有限公司' },
    { name: '东风商用车新疆有限公司' },
    { name: '东风随州专用汽车有限公司' },
    { name: '中通客车控股股份有限公司' },
    { name: '厦门金龙联合汽车工业有限公司' },
    { name: '金龙联合汽车工业（苏州）有限公司' },
    { name: '厦门金龙旅行车有限公司' },
    { name: '北汽福田汽车股份有限公司北京欧辉客车分公司' },
    { name: '保定长安客车制造有限公司' },
    { name: '安徽安凯汽车股份有限公司' },
    { name: '浙江吉利新能源商用车集团有限公司' },
    { name: '三一集团有限公司' },
    { name: '洛阳中集凌宇汽车有限公司' },
    { name: '唐鸿重工专用汽车股份有限公司' },
    { name: '唐山亚特专用汽车有限公司' },
    { name: '芜湖中集瑞江汽车有限公司' },
    { name: '北京福田雷萨泵送机械分公司' },
    { name: '扬州中集通华专用车有限公司' },
    { name: '河南骏通车辆有限公司' },
    { name: '程力重工股份有限公司' },
    { name: '湖南响箭重工科技有限公司' },
    { name: '湖北三环专用汽车有限公司' },
    { name: '徐工施维英机械有限公司' },
    { name: '济宁四通工程机械有限公司' },
    { name: '青岛九合重工机械有限公司' },
    { name: '青岛和盛达重工机械有限公司' },
    { name: '长垣县农建机械设备有限公司' },
    { name: '河南飞龙工程机械制造有限公司' },
    { name: '河南森源重工有限公司' },
    { name: '山东施卫普环保科技有限公司' },
    { name: '济南重诺机械制造有限公司' },
    { name: '兰考神力工程机械有限公司' },
    { name: '湖北华专一专用汽车有限公司' },
    { name: '湖北四通专用汽车有限公司' },
    { name: '湖南慧盟重工科技有限公司' },
    { name: '徐州工程机械集团有限公司' },
    { name: '济宁久邦重工机械有限公司' },
    { name: '中集陕汽重卡（西安）专用车有限公司' }
  ],
  // 合作大客户
  vipData: [
    { name: '焦作汉风汽贸有限公司' },
    { name: '迁安市霖谊汽车销售有限公司' },
    { name: '陕西法耐斯工贸有限公司' },
    { name: '张家口吉朋商贸有限公司' },
    { name: '商丘鼎吉汽车销售有限公司' },
    { name: '南京吉顺汽车销售有限公司' },
    { name: '云南百驰汽车销售有限公司' },
    { name: '济南好运汽汽车服务有限公司' },
    { name: '四川恒诚祥瑞汽车销售有限公司' },
    { name: '宁波联卡汽车销售服务有限公司' },
    { name: '江苏徐工重卡营销中心' },
    { name: '重庆重型汽车集团专用汽车有限责任公司' },
    { name: '湖北华清双福工贸有限公司' },
    { name: '烟台交运货运汽车销售服务有限公司' },
    { name: '滨州市起点精品汽贸有限公司' },
    { name: '德州欧瑞汽车销售服务有限公司' },
    { name: '曲靖博沃汽车销售服务有限公司' },
    { name: '辽宁众汇汽车贸易有限公司' },
    { name: '重庆凯瑞科信汽车销售有限公司' },
    { name: '西安普仕德工贸有限责任公司' },
    { name: '赣州市永恒汽车销售服务有限公司' },
    { name: '南京汪宁今荣汽车销售服务有限公司' },
    { name: '南京豪卡汽车销售服务有限公司' },
    { name: '绍兴市运卡汽车销售服务有限公司' },
    { name: '天津同豪汽车销售有限公司' },
    { name: '山东华采国际贸易有限公司' },
    { name: '广西玉林市汶舟汽车销售有限公司' },
    { name: '唐山鸿勋贸易有限公司' },
    { name: '武汉杭隆汽车销售服务有限公司' },
    { name: '郑州鸿阳汽车销售服务有限公司' },
    { name: '江苏三翼工程机械有限公司' },
    { name: '营口吉程实业有限公司' },
    { name: '滨州锦航汽车销售服务有限公司' },
    { name: '河北赫伦企业管理咨询有限公司' },
    { name: '连云港大喜汽车销售服务有限公司' },
    { name: '四川正同恒晟贸易有限公司' },
    { name: '四川鑫联合卡车销售服务有限公司' },
    { name: '河南广辰汽车销售有限公司' },
    { name: '沧州鑫聚汽车贸易有限公司' },
    { name: '湖北运丰达汽车销售有限公司' }
  ],
  // 合作经销商
  dataName: [
    { name: '焦作汉风汽贸有限公司' },
    { name: '迁安市霖谊汽车销售有限公司' },
    { name: '陕西法耐斯工贸有限公司' },
    { name: '张家口吉朋商贸有限公司' },
    { name: '商丘鼎吉汽车销售有限公司' },
    { name: '南京吉顺汽车销售有限公司' },
    { name: '云南百驰汽车销售有限公司' },
    { name: '济南好运汽汽车服务有限公司' },
    { name: '四川恒诚祥瑞汽车销售有限公司' },
    { name: '宁波联卡汽车销售服务有限公司' },
    { name: '江苏徐工重卡营销中心' },
    { name: '重庆重型汽车集团专用汽车有限责任公司' },
    { name: '湖北华清双福工贸有限公司' },
    { name: '烟台交运货运汽车销售服务有限公司' },
    { name: '滨州市起点精品汽贸有限公司' },
    { name: '德州欧瑞汽车销售服务有限公司' },
    { name: '曲靖博沃汽车销售服务有限公司' },
    { name: '辽宁众汇汽车贸易有限公司' },
    { name: '重庆凯瑞科信汽车销售有限公司' },
    { name: '西安普仕德工贸有限责任公司' },
    { name: '赣州市永恒汽车销售服务有限公司' },
    { name: '南京汪宁今荣汽车销售服务有限公司' },
    { name: '南京豪卡汽车销售服务有限公司' },
    { name: '绍兴市运卡汽车销售服务有限公司' },
    { name: '天津同豪汽车销售有限公司' },
    { name: '山东华采国际贸易有限公司' },
    { name: '广西玉林市汶舟汽车销售有限公司' },
    { name: '唐山鸿勋贸易有限公司' },
    { name: '武汉杭隆汽车销售服务有限公司' },
    { name: '郑州鸿阳汽车销售服务有限公司' },
    { name: '江苏三翼工程机械有限公司' },
    { name: '营口吉程实业有限公司' },
    { name: '滨州锦航汽车销售服务有限公司' },
    { name: '河北赫伦企业管理咨询有限公司' },
    { name: '连云港大喜汽车销售服务有限公司' },
    { name: '四川正同恒晟贸易有限公司' },
    { name: '四川鑫联合卡车销售服务有限公司' },
    { name: '河南广辰汽车销售有限公司' },
    { name: '沧州鑫聚汽车贸易有限公司' },
    { name: '湖北运丰达汽车销售有限公司' },
    { name: '湖北华清双福工贸有限公司' },
    { name: '辽宁山恩运盟物流管理有限公司' },
    { name: '河南万马运输有限公司' },
    { name: '西安鹏博达汽车销售有限公司' },
    { name: '苏州喜洋洋运输有限公司' },
    { name: '湖北四通专用汽车有限公司' },
    { name: '承德恒利汽车销售有限公司' },
    { name: '清远市清新区万山汽车销售有限公司' },
    { name: '绵阳新宏远汽车贸易有限公司' },
    { name: '承德弘润达汽车销售服务有限公司' }
  ],
  companyImg: [
    {
      img: require('@image/dfsyc.png'),
      url: 'http://www.dfcv.com.cn/Index.aspx'
    },
    {
      img: require('@image/zgzq.png'),
      url: 'http://www.cnhtcpurch.com/'
    },
    {
      img: require('@image/sqjt.png'),
      url: 'http://www.sxqc.com/index_zqpc.aspx'
    },
    {
      img: require('@image/fdml.png'),
      url: 'https://www.aumantruck.com/'
    },
    {
      img: require('@image/sqywk.png'),
      url: 'http://www.hongyantruck.com/'
    },
    {
      img: require('@image/jhqc.png'),
      url: 'https://www.jac.com.cn/'
    },
    {
      img: require('@image/xgqc.png'),
      url: 'https://www.xcmg.com/xgqc/'
    },
    {
      img: require('@image/hlxm.png'),
      url: 'http://www.camc.cc/'
    },
    {
      img: require('@image/lhkc.png'),
      url: 'http://www.ctruck.com.cn/'
    },
    {
      img: require('@image/bbzk.png'),
      url: 'http://www.beiben.cn/'
    },
    {
      img: require('@image/jlqc.png'),
      url: 'http://www.jmch.com.cn/'
    },
    {
      img: require('@image/dfhs.jpg'),
      url: 'http://www.dfsyqc.com/'
    },
    {
      img: require('@image/dfxj.png')
    },
    {
      img: require('@image/dfsz.jpg'),
      url: 'http://www.dfztruck.com/'
    },

    // {
    //   img: require('@image/zgzq.png'),
    //   url: 'http://www.dfcv.com.cn/Index.aspx'
    // },
    {
      img: require('@image/ztkc.jpg'),
      url: 'http://www.zhongtong.com/'
    },
    {
      img: require('@image/xmjl.png'),
      url: 'https://www.king-long.com.cn/'
    },
    {
      img: require('@image/hgqc.jpg'),
      url: 'http://www.higer.com/'
    },
    {
      img: require('@image/jllk.jpg'),
      url: 'https://www.xmjl.com/'
    },
    {
      img: require('@image/bjoh.png'),
      url: 'https://auv.foton.com.cn/'
    },
    {
      img: require('@image/cakc.jpg'),
      url: 'http://www.changanzyc.com/'
    },
    {
      img: require('@image/ahak.jpg'),
      url: 'https://www.ankai.com/'
    },
    {
      img: require('@image/jlxny.png'),
      url: 'https://www.geelycv.com/'
    },
    {
      img: require('@image/syjt.png'),
      url: 'https://www.sanygroup.com/'
    },
    {
      img: require('@image/lyqc.png'),
      url: 'https://www.lingyu.com/'
    },
    {
      img: require('@image/thzg.png'),
      url: 'http://www.tanghongzhonggong.cn/#page1'
    },
    {
      img: require('@image/ytzg.png'),
      url: 'http://www.yateauto.com/'
    },
    {
      img: require('@image/rjqc.png'),
      url: 'http://www.cimc-whrj.com/'
    },
    {
      img: require('@image/ftls.png')
      // url: 'http://www.tanghongzhonggong.cn/#page1'
    },
    {
      img: require('@image/zjth.jpg'),
      url: 'http://www.chinatrailer.com/index.html'
    },
    {
      img: require('@image/hnjt.jpg'),
      url: 'http://www.hnjtcl.com'
    },
    {
      img: require('@image/clzg.png'),
      url: 'http://www.clwhi.com/'
    },
    {
      img: require('@image/xjzg.png'),
      url: 'http://www.sinoarr.com/helps/xiangjianzhonggong.html'
    },
    {
      img: require('@image/shst.png'),
      url: 'http://www.sitom.com.cn/company.aspx'
    },
    {
      img: require('@image/xzjx.png'),
      url: 'https://www.xcmg.com/schwing/'
    },
    {
      img: require('@image/jnst.png'),
      url: 'http://www.jnstdc.com/'
    },
    {
      img: require('@image/jhzg.png'),
      url: 'http://www.jiuhezg.com/'
    },
    {
      img: require('@image/qdhsd.png'),
      url: 'http://www.hsdzg.com/'
    },
    {
      img: require('@image/cynj.png'),
      url: 'http://www.cynjjx.com/'
    },
    {
      img: require('@image/xfg.jpg'),
      url: 'http://www.xinfeigong.cn/'
    },
    {
      img: require('@image/syzg.png'),
      url: 'http://www.senyuanhi.com/'
    },
    {
      img: require('@image/sdswp.png'),
      url: 'http://www.mtsweep.com/'
    },
    {
      img: require('@image/jnzn.png'),
      url: 'https://jinanzhongnuo.com/'
    },
    {
      img: require('@image/lksl.png'),
      url: 'http://www.hnslzg.com/'
    },
    {
      img: require('@image/hbhy.png'),
      url: 'http://www.huayizq.com/'
    },
    {
      img: require('@image/hbst.png'),
      url: 'http://www.zqc66.com/'
    },
    {
      img: require('@image/hmzg.png'),
      url: 'http://www.cshammer.net/'
    },
    {
      img: require('@image/xzgcjx.png'),
      url: 'http://xgjx.xcmg.com/'
    },
    {
      img: require('@image/jnjbzg.png'),
      url: 'http://www.jiubangzhonggong.com/'
    },
    {
      img: require('@image/zjcl.jpg'),
      url: 'http://www.xacimc.com/'
    }
  ]
}
export default {
  data
}
